import React, { useEffect, useState, useContext } from "react";
import { WhiteCard } from "../../components/cards";
import { Line } from 'react-chartjs-2'
import CommonService from "../../../supply-chain/services/commonService";
import EntityContext from "../../../../context/entityContext";
import authService from "../../../../services/authService";
import RoleChecker from "../../../../utils/roleChecker";

import useApi from '../../../../hooks/useApi';
import useIsMounted from "../../../../hooks/useIsMounted";
import { CurrencyLabel } from "../../../common/inputs";
import productShortName from "../../../../utils/GetProductShortName";
import { AddButton } from "../../../common/containers/button";
import { browserHistory } from "react-router";

function LoanGraph(props) {

  const isMounted = useIsMounted();
  const { constants, sc_invoice_status } = authService.getCurrentUser();
  const [apprvPaidData, setApPaidData] = useState(null); //set data for funds available
  const [graphData, setGraphData] = useState(null);
  const { selectedBusinessType, entityDetails, terminology, openInvoiceModal, selProduct } = useContext(EntityContext);
  const apprvDataApi = useApi(CommonService.getScApprovepaidCount);

  const Graph = () => (
    <>
      {RoleChecker.check(entityDetails.products, constants.ROLES.CUSTOMER) && (
        <div className="flot-chart-content" id="flot-line-chart"> <Line data={graph} options={options} /></div>
      )}
    </>
  )
  const fetchData = async () => {

    //const { data } = await apprvDataApi.request({ "product_type": constants.PRODUCTS.SUPPLYCHAIN, "userId": entityDetails.a_guid, "selRole": selectedBusinessType });

    if (isMounted()) {
      setApPaidData({
        cardTitle: `Loan Graph`,
        leftLabel: "Principle",
        leftValue: <CurrencyLabel value={`0`} />,
        centerLabel: "Total Loan",
        centerValue:  0,
        rightLabel: "Interest",
        rightValue: <CurrencyLabel value={`0`} />,
        status: "open",
        subTitle: "Loan Graph",
        //primaryBtnRoute: "/client/scf/purchase-invoices",
      });

      //setGraphData(data.graphData);
    }

  }

  const options = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
    responsive: true,
    maintainAspectRatio: true,

  }

  const graph = {
    labels: graphData ? graphData.labels : "",
    datasets: [
      {
        label: 'Amount',
        data: graphData ? graphData.data : "",
        backgroundColor: [
          '#58B07E',
        ],

        borderWidth: 1,
        fill: true,
        backgroundColor: 'rgb(22, 199, 154,0.6)',
        borderColor: 'rgba(0, 88, 122, 1)',
        pointBackgroundColor: "#19456b"
      },
    ],
  }

  useEffect(() => {
    fetchData();
  }, [selectedBusinessType, entityDetails]);

  return (
    <>
      {RoleChecker.check(entityDetails.products, constants.ROLES.CUSTOMER) && (
        <WhiteCard
          loading={apprvDataApi.loading}
          data={apprvPaidData}
          graph={<Graph />}
          cardWidthClass={`col-sm-12`}
        />
      )}
    </>
  )
}
export default React.memo(LoanGraph);